/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offset_TypeInputs */

const en_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset Type`)
};

const fr_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de décalage`)
};

const de_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset-Typ`)
};

const it_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di offset`)
};

const ru_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип смещения`)
};

const es_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de desplazamiento`)
};

const zh_cn2_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`偏移类型`)
};

const ja_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフセットタイプ`)
};

const hi_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफसेट प्रकार`)
};

const pt_pt2_offset_type = /** @type {(inputs: Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de deslocamento`)
};

/**
* | output |
* | --- |
* | "Offset Type" |
*
* @param {Offset_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offset_type = /** @type {((inputs?: Offset_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offset_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offset_type(inputs)
	if (locale === "de") return de_offset_type(inputs)
	if (locale === "it") return it_offset_type(inputs)
	if (locale === "ru") return ru_offset_type(inputs)
	if (locale === "es") return es_offset_type(inputs)
	if (locale === "zh-CN") return zh_cn2_offset_type(inputs)
	if (locale === "ja") return ja_offset_type(inputs)
	if (locale === "hi") return hi_offset_type(inputs)
	if (locale === "pt-PT") return pt_pt2_offset_type(inputs)
	return en_offset_type(inputs)
});